import React from 'react'
import {Button, Form, FormGroup, Input, InputGroup, InputGroupAddon, Label} from 'reactstrap'
import AddIcon from 'react-icons/lib/fa/plus'
import RemoveIcon from 'react-icons/lib/fa/minus'

class ProvisionControllerForm extends React.Component {
    handleSubmit = (e) => {
        e.preventDefault()
        const {controllers, registration} = this.state
        const serials = controllers.map((value) => value.serialNumber)
        const iccid = registration ? [] : controllers.map((value) => value.iccid.replace(/\D/g, ''))
        const phone = registration ? [] : controllers.map((value) => value.phoneNumber.replace(/\D/g, ''))
        this.onSubmit(serials, iccid, phone)
        this.setState({controllers: [{serialNumber: '', iccid: '', phoneNumber: ''}]})
    }
    handleControllerSerialChange = (idx) => (evt) => {
        const {controllers} = this.state
        const newControllers = controllers.map((controller, sidx) => {
            if (idx !== sidx) {
                return controller
            }
            return {...controller, serialNumber: evt.target.value}
        })
        this.setState({controllers: newControllers})
    }
    handleControllerICCIDChange = (idx) => (evt) => {
        const {controllers} = this.state
        const newControllers = controllers.map((controller, sidx) => {
            if (idx !== sidx) {
                return controller
            }
            return {...controller, iccid: evt.target.value}
        })
        this.setState({controllers: newControllers})
    }
    handleControllerphoneChange = (idx) => (evt) => {
        const {controllers} = this.state
        const newControllers = controllers.map((controller, sidx) => {
            if (idx !== sidx) {
                return controller
            }
            return {...controller, phoneNumber: evt.target.value}
        })
        this.setState({controllers: newControllers})
    }
    handleAddController = () => {
        this.setState({controllers: this.state.controllers.concat([{serialNumber: '', iccid:'', phoneNumber: ''}])})
    }
    handleRemoveController = (idx) => () => {
        this.setState({controllers: this.state.controllers.filter((s, sidx) => idx !== sidx)})
    }

    constructor(props) {
        super(props)
        const {onSubmit, registration} = props
        this.state = {
            registration,
            controllers: [{serialNumber: '', iccid: '', phoneNumber: ''}]
        }
        this.onSubmit = onSubmit
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleControllerSerialChange = this.handleControllerSerialChange.bind(this)
        this.handleAddController = this.handleAddController.bind(this)
        this.handleRemoveController = this.handleRemoveController.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const {onSubmit, registration} = nextProps
        this.onSubmit = onSubmit
        this.setState({registration})
    }

    render() {
        let {controllers, registration} = this.state
        return <Form onSubmit={this.handleSubmit} className="col-12 col-sm-10 col-md-8 col-lg-6 offset-0 offset-sm-1 offset-md-2 offset-lg-3 no-gutters">
            <FormGroup>
                <Label className="text-left col-12 no-gutters m-0 p-0 text-secondary small">New Controllers</Label>
                {controllers.map((controller, idx) => (
                   
                    <InputGroup key={idx}>
                        <Input type="phone"
                               placeholder={`Serial Number #${idx + 1}`}
                               value={controller.serialNumber}
                               onChange={this.handleControllerSerialChange(idx)} required/>
                        {!registration ? <Input type="phone" maxLength="20"
                               placeholder={`iccid #${idx + 1}`}
                               value={controller.iccid}
                               onChange={this.handleControllerICCIDChange(idx)}/> : null}
                        {!registration ? <Input type="phone" maxLength="15"
                               placeholder={`Phone Number #${idx + 1}`}
                               value={controller.phoneNumber}
                               onChange={this.handleControllerphoneChange(idx)} /> : null}
                   
                        <InputGroupAddon>
                            {(idx === controllers.length - 1 || controllers.length === 1 ?
                                <Button onClick={this.handleAddController}>
                                    <AddIcon/>
                                </Button> :
                                <Button onClick={this.handleRemoveController(idx)}>
                                    <RemoveIcon/>
                                </Button>)}
                        </InputGroupAddon>
                    </InputGroup>))}
            </FormGroup>
            <Button>{(registration ? "Register" : "Provision")}</Button>
        </Form>
    }
}

export default ProvisionControllerForm



// WEBPACK FOOTER //
// ./src/components/ui/ProvisionControllerForm.js